import { render, staticRenderFns } from "./CardProduct.vue?vue&type=template&id=cac28846&"
import script from "./CardProduct.vue?vue&type=script&lang=ts&"
export * from "./CardProduct.vue?vue&type=script&lang=ts&"
import style0 from "./CardProduct.vue?vue&type=style&index=0&lang=less&"
import style1 from "./CardProduct.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports